import { render, staticRenderFns } from "./AddFundsModal.vue?vue&type=template&id=dd8de026"
import script from "./AddFundsModal.vue?vue&type=script&lang=js"
export * from "./AddFundsModal.vue?vue&type=script&lang=js"
import style0 from "./AddFundsModal.vue?vue&type=style&index=0&id=dd8de026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports